import { render, staticRenderFns } from "./gj-icon.vue?vue&type=template&id=48575ea4&scoped=true&"
import script from "./gj-icon.vue?vue&type=script&lang=js&"
export * from "./gj-icon.vue?vue&type=script&lang=js&"
import style0 from "./gj-icon.vue?vue&type=style&index=0&id=48575ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48575ea4",
  null
  
)

export default component.exports